<template>
  <div class="sidebar-horizontal">
    <b-navbar toggleable="md" :container="false" variant="primary" class="navbar-dark">
      <b-container>
        <div class="nav-header d-flex justify-content-center w-100">
          <router-link to="/" class="navbar-brand"><p>{{ $config.name }}</p></router-link>
        </div>

        <b-navbar-nav class="ms-auto">
          <b-nav-item v-if="previousPath !== undefined">
            <button type="button" class="fs-48 text-white btn btn-link px-3" @click="close">&times;</button>
          </b-nav-item>
        </b-navbar-nav>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>

export default {
  props: {
    previousPath: String,
  },
  methods: {
    close() {
      this.$router.push(this.previousPath);
    },
  },
};
</script>
